import { Injectable, Inject } from '@angular/core';
import { FilePreviewApi, API_BASE_URL, CandidateDocuments } from './api.gen';

@Injectable()
export class OpenFilePreviewService {

  baseUrl: string;
  uriSchemes = {
    doc: 'ms-word:ofv|u|',
    docx: 'ms-word:ofv|u|',
    xlsx: 'ms-excel:ofv|u|',
    xls: 'ms-excel:ofv|u|',
    csv: 'ms-excel:ofv|u|',
  };


  constructor(
    private filePreviewService: FilePreviewApi,
    @Inject(API_BASE_URL) baseUrl?: string) {
    this.baseUrl = baseUrl;
  }

  previewFile(token: string, fileGuid: string, filename: string): Promise<boolean> {
    return new Promise((resolve, reject) => {

      const fileExt = this.getFileExtension(filename);

      if (Object.keys(this.uriSchemes).find(r => r === fileExt)) {
        this.openInNativeApplication(token, fileExt, filename);
        resolve(true);
      } else {
        reject(false);
      }
    });
  }

  constructUrl(token: string, filename: string): string {
    return `${this.baseUrl}/api/FilePreview/remote/${token}/${filename}`;
  }

  constructPDFUrl(token: string, filename: string): string {
    return `${this.baseUrl}/api/FilePreview/preview/${token}/${filename}`;
  }

  openInNativeApplication(token: string, fileExt: string, filename: string) {
    window.open(`${this.uriSchemes[fileExt]}${this.constructUrl(token, filename)}`, '_blank');
  }

  previewAttachmentFile(filename: string) {
    const file = this.getFileName(filename);
    const fileExt = this.getFileExtension(filename);
    window.open(`${this.uriSchemes[fileExt]}${this.baseUrl}/api/FilePreview/local/${file}`, '_blank');
  }

  private getFileExtension(filename: string): string {
    return filename.split('.').pop();
  }

  private getFileName(filePath: string): string {
    const filename = filePath.replace(/^.*[\\\/]/, '');
    return filename;
  }

  private normalizePath(filePath: string): string {
    let filename = filePath.replace('\\', '+');
    filename = filePath.replace(':', '_');
    return filename;
  }

  getFilePreviewToken(details: CandidateDocuments) {
    return this.filePreviewService.fileToken(details.fileGuiId).toPromise();
  }

}
